import Vue from 'vue';
import walletApi from './WalletAPI';
import notificationAPI from './NotificationAPI';
import faqAPI from './faqAPI';
import steamPurchaseAPI from './steamPurchaseAPI';
import './dialog';
import a2s from './a2s';

Vue.use(a2s);
Vue.use(walletApi);
Vue.use(notificationAPI);
Vue.use(faqAPI);
Vue.use(steamPurchaseAPI);
